import { render, staticRenderFns } from "./DownloadJumbo.vue?vue&type=template&id=e1141844&"
import script from "./DownloadJumbo.vue?vue&type=script&lang=js&"
export * from "./DownloadJumbo.vue?vue&type=script&lang=js&"
import style0 from "./DownloadJumbo.vue?vue&type=style&index=0&id=e1141844&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports